import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, Box, ListItemIcon, ListItemText } from "@mui/material";

const FLAGS = {
	es: "https://flagcdn.com/es.svg",
	en: "https://flagcdn.com/us.svg",
	pt: "https://flagcdn.com/br.svg",
};

const LanguageSwitcher = ({ compact = false }) => {
	const { i18n } = useTranslation();
	const [language, setLanguage] = useState(i18n.language || "es");

	const handleChange = (event) => {
		const selectedLanguage = event.target.value;
		setLanguage(selectedLanguage);
		i18n.changeLanguage(selectedLanguage);
		localStorage.setItem("i18nextLng", selectedLanguage);
	};

	/** Cómo se ve el valor ya seleccionado en el input */
	const renderValue = (value) => (
		<Box sx={{ display: "flex", alignItems: "center" }}>
			<img src={FLAGS[value]} alt={value} style={{ width: 20, height: 20 }} />
			{/* Solo mostramos texto si NO estamos en modo compacto */}
			{!compact && (
				<Box component="span" sx={{ ml: 1, fontSize: 14 }}>
					{value === "es" ? "Español" : value === "en" ? "English" : "Português BR"}
				</Box>
			)}
		</Box>
	);

	return (
		<Box sx={{ display: "flex", justifyContent: compact ? "center" : "flex-end" }}>
			<Select
				value={language}
				onChange={handleChange}
				variant="outlined"
				renderValue={renderValue}
				sx={{
					border: "none",
					".MuiOutlinedInput-notchedOutline": { border: "none" },
					minWidth: compact ? 48 : 120, // ancho reducido cuando es compacto
					"& .MuiSelect-select": { p: compact ? 0 : "8px 14px" },
				}}
			>
				{["es", "en", "pt"].map((lng) => (
					<MenuItem key={lng} value={lng}>
						<ListItemIcon sx={{ minWidth: 30 }}>
							<img src={FLAGS[lng]} alt={lng} style={{ width: 20, height: 20 }} />
						</ListItemIcon>
						{/* Dentro del menú siempre mostramos el texto para que sea accesible */}
						<ListItemText
							primary={lng === "es" ? "Español" : lng === "en" ? "English" : "Português BR"}
						/>
					</MenuItem>
				))}
			</Select>
		</Box>
	);
};

LanguageSwitcher.propTypes = {
	compact: PropTypes.bool,
};

export default LanguageSwitcher;
